import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DotsSixVertical } from "@phosphor-icons/react";

export const SortableItem = ({ id, children, testIdPrefix = "item" }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    zIndex: isDragging ? 20 : "auto",
  };

  return (
    <div ref={setNodeRef} style={style} className="relative">
      <button
        type="button"
        {...attributes}
        {...listeners}
        className="absolute top-3 right-3 z-10 w-9 h-9 bg-[#141e32]/95 border border-[#2c3854] hover:border-[#af3fa6] hover:text-[#af3fa6] flex items-center justify-center cursor-grab active:cursor-grabbing transition-colors shadow-sm"
        aria-label="Drag to reorder"
        data-testid={`${testIdPrefix}-drag-handle-${id}`}
        title="Drag to reorder"
      >
        <DotsSixVertical size={16} weight="bold" />
      </button>
      {children}
    </div>
  );
};

export default SortableItem;
